module.exports = __webpack_public_path__ + "img/alert_orange.30a2376f.svg";